import { render } from "./MessageContainer.vue?vue&type=template&id=cb17f4ce"
import script from "./MessageContainer.vue?vue&type=script&lang=ts"
export * from "./MessageContainer.vue?vue&type=script&lang=ts"
script.render = render

export default script